export const DotStrip = ({ className = "text-nexa-red" }) => (
  <div className={`dot-strip w-full ${className}`} aria-hidden="true" />
);
